import style from "../style/Projects.module.css";

export default function Projects() {
    return (
        <>
            <h1 className={style.sectionTitle}>My projects</h1>

            <div className={style.container}>
                <div className={style.project}>
                    <div className={style.projectBg} style={{ backgroundImage: "url('https://user-images.githubusercontent.com/53608074/201397177-1d08c4ed-d595-41ab-86cb-3e8bd1da46dd.png')" }}></div>
                    <h2 className={style.title}>AMRPC</h2>
                    <p className={style.description}>
                        Rich Presence for Apple Music & iTunes — shows currently playing tracks with cover art and info on Discord. Cross-platform, open source, customizable.
                    </p>

                    <div className={style.btns}>
                        <a className={style.btn} href={"https://github.com/zephraOSS/Apple-Music-RPC"} target={"_blank"} rel={"noreferrer"}>GitHub</a>
                        <a className={style.btn} href={"https://amrpc.vercel.app"} target={"_blank"} rel={"noreferrer"}>Website</a>
                    </div>
                </div>

                <div className={style.project}>
                    <div className={style.projectBg} style={{ backgroundImage: "url('https://cdn.prod.website-files.com/6257adef93867e50d84d30e2/665643dd8c7ac752237b5cef_Discord-OG-1200x630.jpg')" }}></div>
                    <h2 className={style.title}>zaphy™</h2>
                    <p className={style.description}>
                        A versatile Discord bot with features like music playback, moderation, and fun commands — flexible, easy to configure, and open source.
                    </p>

                    <div className={style.btns}>
                        <a className={style.btn} href={"https://github.com/zephraOSS/zaphy"} target={"_blank"} rel={"noreferrer"}>GitHub</a>
                    </div>
                </div>

                <div className={style.project}>
                    <div className={style.projectBg} style={{ backgroundImage: "url('https://user-images.githubusercontent.com/53608074/180813950-8fcad045-489a-4deb-891f-3f0ea41999ce.png')" }}></div>
                    <h2 className={style.title}>Memoji-iMac</h2>
                    <p className={style.description}>
                        Create a Memoji sitting at an iMac. This HTML-based generator allows you to design and download personalized Memoji avatars. Ideal for profile pictures, social media, or just for fun.
                    </p>

                    <div className={style.btns}>
                        <a className={style.btn} href={"https://github.com/zephraOSS/Memoji-iMac"} target={"_blank"} rel={"noreferrer"}>GitHub</a>
                    </div>
                </div>

                <div className={style.project}>
                    <div className={style.projectBg} style={{ backgroundImage: "url('https://images.pexels.com/photos/225502/pexels-photo-225502.jpeg')" }}></div>
                    <h2 className={style.title}>Battify</h2>
                    <p className={style.description}>
                        Receive PC notifications when your iPhone or iPad reaches a specified battery percentage. Utilizes a simple Windows app and a customizable Siri Shortcut for seamless integration.
                    </p>

                    <div className={style.btns}>
                        <a className={style.btn} href={"https://github.com/zephraOSS/Battify"} target={"_blank"} rel={"noreferrer"}>GitHub</a>
                    </div>
                </div>

                <div className={style.project}>
                    <div className={style.projectBg}></div>
                    <h2 className={style.title}>Apple-Bridge</h2>
                    <p className={style.description}>
                        A cross-platform library for retrieving data from Apple services like Apple Music and Apple TV on macOS and Windows. It provides real-time event listeners for playback states and metadata, enabling seamless integration with applications such as Discord bots or custom music status displays. Supports both JavaScript and TypeScript environments.
                    </p>

                    <div className={style.btns}>
                        <a className={style.btn} href={"https://github.com/zephraOSS/Apple-Bridge"} target={"_blank"} rel={"noreferrer"}>GitHub</a>
                    </div>
                </div>

                <div className={style.project}>
                    <div className={style.projectBg} style={{ backgroundImage: "url('/amaac_snapshot.png')" }}></div>
                    <h2 className={style.title}>AMAC</h2>
                    <p className={style.description}>
                        <b>Apple Music Album Art Creator</b><br />
                        Create Apple Music‑style playlist covers in seconds. A Next.js-based tool that lets you design and export album-like artwork effortlessly. Not optimized for mobile.
                    </p>

                    <div className={style.btns}>
                        <a className={style.btn} href={"https://github.com/zephraOSS/Apple-Music-Art-Creator"} target={"_blank"} rel={"noreferrer"}>GitHub</a>
                        <a className={style.btn} href={"https://amaac.vercel.app"} target={"_blank"} rel={"noreferrer"}>Website</a>
                    </div>
                </div>
            </div>
        </>
    )
}